// React
import React from 'react';

// Styles
import styles from './Dashboard.module.scss';
import { ReactComponent as TrimIcon } from '../../../images/icon-trim.svg';
// import { ReactComponent as PricingIcon } from '../../../images/icon-pricing.svg';
// import { ReactComponent as DiscountsIncentivesIcon } from '../../../images/icon-discounts-incentives.svg';
import { ReactComponent as GearboxIcon } from '../../../images/icon-gearbox.svg';
import { ReactComponent as ModelIcon } from '../../../images/icon-model.svg';
import { ReactComponent as SalesVersionIcon } from '../../../images/icon-sales-version.svg';
import { ReactComponent as SalesChannelIcon } from '../../../images/icon-sales-channel.svg';
import { ReactComponent as EngineIcon } from '../../../images/icon-engine.svg';
import { ReactComponent as StandardFeaturesIcon } from '../../../images/icon-standard-features.svg';
import { ReactComponent as ColorsIcon } from '../../../images/icon-colors.svg';
import { ReactComponent as UpholsteryIcon } from '../../../images/icon-upholstery.svg';
import { ReactComponent as PackagesIcon } from '../../../images/icon-packages.svg';
import { ReactComponent as PackagesIcon2 } from '../../../images/icon-packages2.svg';
import { ReactComponent as OptionsIcon } from '../../../images/icon-options.svg';
import { ReactComponent as VistaOrdersIcon } from '../../../images/icon-vista-orders.svg';

// Third party
import { Link as RouterLink } from 'react-router-dom';

// Material UI
import { Grid, Typography, Link } from '@material-ui/core';

// This component
export default function Dashboard() {

  // JSX
  return (
    <div className={styles.wrapper}>
      <Typography variant="h1" component="h1" className={styles.title}>
        Volvo Cars Data Hub
      </Typography>

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <div className={styles.box}>
            <Typography variant="h3" component="h2" className={styles.subtitle}>
              App Controls
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/sales-channel"
                className={styles.link}>
                <SalesChannelIcon className={styles.icon} />  Sales Channels
              </Link>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div className={styles.box}>
            <Typography variant="h3" component="h2" className={styles.subtitle}>
              Data Integrations
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/vista-order"
                className={styles.link}>
                <VistaOrdersIcon className={styles.icon} /> Vista Orders
              </Link>
            </Typography>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={4}>

      <Grid item xs={12} md={6}>
          <div className={styles.box}>
            <Typography variant="h3" component="h2" className={styles.subtitle}>
              Vehicle Configuration
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/vehicle"
                className={styles.link}>
                <TrimIcon className={styles.icon} /> Available Vehicles
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/color"
                className={styles.link}>
                <ColorsIcon className={styles.icon} /> Exterior - Colors
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/upholstery"
                className={styles.link}>
                <UpholsteryIcon className={styles.icon} /> Interior - Upholstery
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/package"
                className={styles.link}>
                <PackagesIcon2 className={styles.icon} /> Packages
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/option"
                className={styles.link}>
                <OptionsIcon className={styles.icon} /> Options
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/accessory"
                className={styles.link}>
                <PackagesIcon className={styles.icon} /> Accessories
              </Link>
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div className={styles.box}>
            <Typography variant="h3" component="h2" className={styles.subtitle}>
              Vehicle Components
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/model"
                className={styles.link}>
                <ModelIcon className={styles.icon} /> Models
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/engine"
                className={styles.link}>
                <EngineIcon className={styles.icon} /> Engine
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/sales-version"
                className={styles.link}>
                <SalesVersionIcon className={styles.icon} /> Sales Versions
              </Link>
            </Typography>

            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/transmission"
                className={styles.link}>
                <GearboxIcon className={styles.icon} /> Transmission
              </Link>
            </Typography>
            
            <Typography variant="h3" component="h3" className={styles.item}>
              <Link
                component={RouterLink}
                underline="none"
                to="/standard-feature"
                className={styles.link}>
                <StandardFeaturesIcon className={styles.icon} /> Standard
                Features
              </Link>
            </Typography> 
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
